import { normalizePickerDateTime } from "../../pages/_new/detection/wafEventListUtils";

export { normalizePickerDateTime };

export function splitDateTimeLocal(value) {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const fallbackDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const fallbackTime = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
  if (!value) {
    return { date: fallbackDate, time: fallbackTime };
  }
  const [date, timePart] = String(value).split("T");
  const time = (timePart || "00:00").substring(0, 5);
  return {
    date: date || fallbackDate,
    time: time || fallbackTime,
  };
}

export function formatDisplayValue(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function pickerValueToDateTimeLocal(part) {
  return normalizePickerDateTime(part).slice(0, 16);
}

export function todayDateString() {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

export function isDateBeforeToday(dateStr) {
  if (!dateStr) return false;
  return String(dateStr).slice(0, 10) < todayDateString();
}

export function isDateTimeLocalBeforeNow(value) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return false;
  const ms = new Date(trimmed).getTime();
  return Number.isFinite(ms) && ms < Date.now();
}

export function isExpiryDateBeforeToday(dateStr) {
  return isDateBeforeToday(dateStr);
}
